// Version : 0.0.1
// Author : Agalya

const BusinessLoanDisbursementActionTypes = {
	/*********** FETCH BUSINESS LOAN INDEX START ************************ */
	FETCH_BUSINESS_LOAN_INDEX_START: 'fetch_business_loan_index_start',
	FETCH_BUSINESS_LOAN_INDEX_SUCCESS: 'fetch_business_loan_index_success',
	FETCH_BUSINESS_LOAN_INDEX_FAILURE: 'fetch_business_loan_index_failure',
	FETCH_BUSINESS_LOAN_INDEX_RESPONSE_RESET: 'fetch_business_loan_index_response_reset',
	FETCH_BUSINESS_LOAN_INDEX_RESPONSE_CHANGED: 'fetch_business_loan_index_response_changed',
	/*********** FETCH BUSINESS LOAN INDEX END ************************ */

	/*********** FETCH FINANCE BASED ACCOUNT TYPE START ************************ */
	FETCH_FINANCE_BASED_ACCOUNT_TYPE_START: 'fetch_finance_based_account_type_start',
	FETCH_FINANCE_BASED_ACCOUNT_TYPE_SUCCESS: 'fetch_finance_based_account_type_success',
	FETCH_FINANCE_BASED_ACCOUNT_TYPE_FAILURE: 'fetch_finance_based_account_type_failure',
	FETCH_FINANCE_BASED_ACCOUNT_TYPE_RESPONSE_RESET:
		'fetch_finance_based_account_type_response_reset',
	FETCH_FINANCE_BASED_ACCOUNT_TYPE_RESPONSE_CHANGED:
		'fetch_finance_based_account_type_response_changed',
	/*********** FETCH FINANCE BASED ACCOUNT TYPE END ************************ */

	/*********** BUSINESS LOAN DISBURSEMENT START ************************ */
	BUSINESS_LOAN_DISBURSEMENT_START: 'business_loan_disbursement_start',
	BUSINESS_LOAN_DISBURSEMENT_SUCCESS: 'business_loan_disbursement_success',
	BUSINESS_LOAN_DISBURSEMENT_FAILURE: 'business_loan_disbursement_failure',
	BUSINESS_LOAN_DISBURSEMENT_RESPONSE_RESET: 'business_loan_disbursement_response_reset',
	BUSINESS_LOAN_DISBURSEMENT_RESPONSE_CHANGED: 'business_loan_disbursement_response_changed',
	/*********** BUSINESS LOAN DISBURSEMENT END ************************ */

	/*********** FETCH BUSINESS LOAN INFO DETAILS START ************************ */
	FETCH_BUSINESS_LOAN_INFO_DETAILS_START: 'fetch_business_loan_info_details_start',
	FETCH_BUSINESS_LOAN_INFO_DETAILS_SUCCESS: 'fetch_business_loan_info_details_success',
	FETCH_BUSINESS_LOAN_INFO_DETAILS_FAILURE: 'fetch_business_loan_info_details_failure',
	FETCH_BUSINESS_LOAN_INFO_DETAILS_RESPONSE_RESET:
		'fetch_business_loan_info_details_response_reset',
	FETCH_BUSINESS_LOAN_INFO_DETAILS_RESPONSE_CHANGED:
		'fetch_business_loan_info_details_response_changed',
	/*********** FETCH BUSINESS LOAN INFO DETAILS END ************************ */

	/*********** GET BUSINESS LIST START ************************ */
	GET_BUSINESS_LIST_START: 'get_business_list_start',
	GET_BUSINESS_LIST_SUCCESS: 'get_business_list_success',
	GET_BUSINESS_LIST_FAILURE: 'get_business_list_failure',
	GET_BUSINESS_LIST_RESPONSE_RESET: 'get_business_list_response_reset',
	GET_BUSINESS_LIST_RESPONSE_CHANGED: 'get_business_list_response_changed',
	/*********** GET BUSINESS LIST END ************************ */
};
export default BusinessLoanDisbursementActionTypes;
